<div class="country">
  <mat-dialog-content class="country-content">
    <h2>Selecciona tu país</h2>
    <div></div>
  </mat-dialog-content>
  <mat-dialog-actions class="country-actions">
    <button
      mat-raised-button
      class="button-close"
      [mat-dialog-close]="'co'"
      *ngIf="creditType !== '1'"
    >
      <div class="container-button">
        <img
          src="assets/country-flags/colombia.png"
          alt="colombia"
          class="image"
        />
        <div>Colombia</div>
        <mat-icon>arrow_right_alt</mat-icon>
      </div>
    </button>
    <button mat-raised-button class="button-close" [mat-dialog-close]="'mx'">
      <div class="container-button">
        <img src="assets/country-flags/mexico.png" alt="méxico" class="image" />
        <div>México</div>
        <mat-icon>arrow_right_alt</mat-icon>
      </div>
    </button>
  </mat-dialog-actions>
</div>
